// Angular
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// Rx
import { of as observableOf, Observable } from 'rxjs';
import { delay } from 'rxjs/operators';

// Environment
import { environment } from 'environments/environment';

// 3rd Party
import { JwtHelperService } from '@auth0/angular-jwt';
import { NotificationBarService, NotificationType } from 'ngx-notification-bar';

@Injectable()
export class AuthService {
    public notificationBarService: NotificationBarService;

    private jwtHelper: JwtHelperService = new JwtHelperService();
    private token: string;
    private authenticationProvider: string;

    constructor(
        private route?: ActivatedRoute,
        private router?: Router,
    ) {
        const currentToken = localStorage.getItem(environment.TokenName);
        const authenticationProvider = localStorage.getItem(environment.AuthenticationProvider);

        this.token = (currentToken == null) ? null : JSON.parse(currentToken)['token'];
        this.authenticationProvider = (authenticationProvider == null) ? null : authenticationProvider;
    }

    public logout(): void {
        console.log('>>> AuthService: logout()');

        this.token = null;
        localStorage.removeItem(environment.TokenName);
        localStorage.clear();
    }

    public getToken(): any {
        console.log('>>> AuthService: getToken()');

        if (!this.token || this.jwtHelper.isTokenExpired(this.token)) {
            const currentToken = localStorage.getItem(environment.TokenName);

            this.token = (currentToken == null) ? null : JSON.parse(currentToken)['token'];
        }

        return this.token;
    }

    public getAuthenticationProvider(): any {
        console.log('>>> AuthService: getAuthenticationProvider()');

        if (!this.authenticationProvider) {
            const authenticationProvider = localStorage.getItem(environment.AuthenticationProvider);

            this.authenticationProvider = authenticationProvider;
        }

        return this.authenticationProvider;
    }

    public setAuthenticationProvider(authenticationProvider: string): any {
        console.log('>>> AuthService: setAuthenticationProvider()');

        localStorage.setItem(environment.AuthenticationProvider, authenticationProvider);
    }

    public isUserLoggedIn(): boolean {
        console.log('>>> AuthService: isUserLoggedIn()');

        return this.token == null ? false : !this.jwtHelper.isTokenExpired(this.token);
    }
}
